// extracted by mini-css-extract-plugin
export default {"container":"document-text-card_container__2ZNXc","link":"document-text-card_link___zx0k","icon":"document-text-card_icon__6w_EC"};